const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000/api'
}

export default config
